module.exports = __webpack_public_path__ + "static/media/The Grand Orchestra.a8be70bf.png";